import { render, staticRenderFns } from "./ImageBatchUpload.vue?vue&type=template&id=657e72b3&scoped=true"
import script from "./ImageBatchUpload.vue?vue&type=script&lang=js"
export * from "./ImageBatchUpload.vue?vue&type=script&lang=js"
import style0 from "./ImageBatchUpload.vue?vue&type=style&index=0&id=657e72b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657e72b3",
  null
  
)

export default component.exports